import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  optionCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#f9f9f9',
      borderColor: '#FF4500',
    },
    '& .MuiFormControlLabel-root': {
      width: '100%',
      margin: 0,
    },
  },
  otpContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '& .otp-input-container': {
      display: 'flex',
      gap: '8px',
      justifyContent: 'center',
    },
    '& .otp-input': {
      width: '48px !important',
      height: '56px',
      fontSize: '20px',
      borderRadius: '4px',
      border: '1px solid #ccc',
      textAlign: 'center',
      '&:focus': {
        borderColor: '#FF4500',
        outline: 'none',
      },
    },
    '& .otp-input--focused': {
      borderColor: '#FF4500',
    },
  },
  otpLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  centeredTitle: {
    textAlign: 'center',
    minWidth: '500px',
    whiteSpace: 'nowrap',
  },
  centeredContent: {
    textAlign: 'center',
  },
  phoneInput: {
    marginBottom: theme.spacing(2),
    '& .PhoneInput': {
      width: '100%',
      maxWidth: '300px',
      height: '40px',
      padding: '9px',
      border: '1px solid #777',
    },
    '& .PhoneInput:hover': {
      border: '1px solid #222',
      borderRadius: '0px',
    },
    '& .PhoneInput:focus-within': {
      border: '1px solid #ff4500',
    },
    '& .PhoneInputCountryIcon': {
      backgroundColor: 'none',
      boxShadow: 'unset',
      border: '0.5px solid #2223',
    },
    '& input': {
      fontSize: '16px',
      outline: 'none',
      border: 'none',
      width: '100%',
    },
  },
  inputLabel: {
    color: '#2E343B',
    fontSize: '14px',
    lineHeight: '24px',
    marginBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  resendContainer: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  resendLink: {
    color: '#FF4500',
    cursor: 'pointer',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  resendDisabled: {
    color: '#999',
    cursor: 'default',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  resendSuccess: {
    color: '#4caf50',
    fontSize: '14px',
  },
}))

export default useStyles
